export default __webpack_public_path__ + "static/media/TC.3fb194a7.svg";